import React from 'react';
import { MuiThemeProvider, createTheme } from '@material-ui/core/styles';
// import {
//   light,
//   grey,
//   dark,
//   disabledColor,
//   backgroundColor,
//   primaryColor,
//   primaryColorLight,
//   secondaryColor,
//   tertiaryColor,
//   bodyColor,
//   titleColor,
// } from 'helpers/colors';


const palette = {
    type: 'light',
    primary: {
      main: '#6C207E', // bleu
      // light: '#6fcaf2', //bleu light
      light: '#6C207E', //bleu light
      dark: '#0b4b80'
    },
    secondary: {
      main: '#6C207E', // rouge
      light: '#E37EB3',
      contrastText: '#fff',
    },
    tertiary: {
      main: '#87c7a6',
    },
    text: {
      primary: '#212121',
      light: '#eee'
      // secondary: secondaryColor,
      // light,
      // dark,
    },
    action: {
      // disabled: disabledColor,
    },
    background: {
      default: '#fff',
      // input: primaryColor,
      // paper: '#fff',
    },
    header: {
      buttonColor: 'inherit',
      buttonBackgroundColor: 'transparent',
      buttonBorder: '',
      buttoBorderBottom: '4px transparent solid',
      buttoHoverColor: '#B694C5',
      // buttonHoverBorderBottom: '4px #E37EB3 solid',
      buttonSelectedColor: '#E37EB3',
      buttonSelectedBackgroundColor: 'transparent',
      buttonSelectedBeforeContent: "' '",
      buttonSelectedBorderBottom: '4px #B694C5 solid',
      buttonFontWeight: 'bold'
    },
    faq: {
      backgroundColor: undefined,
      bulletColor: '#6C207E',
      itemColor: '#0087AF',
      itemBackgroundColor: '#fff',
      itemShadow: '1px 1px 6px #666',
      textColor: '#0087AF',
      answerColor: '#0087AF',
    },
    speedTest: {
      backgroundColor: 'transparent',
      color: '#fff',
      buttonColor: '#fff',
      buttonBackgroundColor: '#6C207E',
    },
    footer: {
      color: '#fff',
      linkColor: '#fff',
      background: '#6C207E'
    },
    news: {
      backgroundColor: '#F4F4F4',
      color: '#212121'
    },
    replays: {
      breadCrumbColor: '#fff',
      backgroundColor: '#6C207E',
    },
    live: {
      breadCrumbColor: '#fff',
      backgroundColor: '#6C207E',
    },
    template: {
      color: '#212121'
    },
    registration: {
      titleColor: '#212121'
    },
    rgpd: {
      backgroundColor: '#6C207E',
      color: '#fff',
    }
  }

export default class Theme extends React.Component {
  render() {
    const { children } = this.props;

    const theme = createTheme({
      palette,
      typography: {
        // fontFamily: ['Aleo, Arial, sans-serif'].join(','),
        fontFamily: ['Montserrat, sans-serif'].join(','),
        useNextVariants: true,
        h1: {
          fontSize: '3.625rem',
          marginTop: 8*4,
          marginBottom: 8*12,
          textAlign: 'center',
          // color: palette.primary.dark,
          color: '#fff',
          fontWeight: 'normal'
        },
        h2: {
          fontSize: '2.1875rem',
          '& a': {
            color: 'inherit'
          }
        },
        h3: {
          fontSize: '2rem',
          marginBottom: 24
        },
        h5: {
          fontSize: '1.375rem',
          color: palette.secondary.main,
          display: 'block',
          lineHeight: '2.1875rem',
          '& .MuiSvgIcon-root': {
            // marginTop: -6,
            marginRight: 8,
            // marginBottom: 8
          }
        },
        h6: {
          color: '#E37EB3',
          fontWeight: 'bold',
        },
        body1: {
          fontSize: '0.9375rem',
          lineHeight: '1.4375rem'
        },
        caption: {
          lineHeight: '1.4375rem',
          color: '#898089'

        }
        // h1: {
        //   // color: titleColor || light,
        //   fontWeight: 'bold',
        //   // display: 'inline-block',
        //   fontSize: '2.6rem',
        //   // borderBottom: (titleColor || light) + ' 1px solid',
        //   marginBottom: 30,
        //   // paddingBottom: 10,
        //   letterSpacing: 2,
        //
        //   paddingTop: 16,
        //   paddingBottom: 16,
        //   // color: primaryColor,
        //   textAlign: 'center',
        //   fontSize: '1.6rem',
        //   fontWeight: 'normal',
        //   // backgroundColor: '#fff',
        //   width: '100%',
        //
        // },
        // h2: {
        //   textAlign: 'center',
        //   fontSize: '2rem',
        //   lineHeight: '2.4rem',
        //   fontWeight: 'bold',
        //   textTransform: 'uppercase',
        //   display: 'block',
        //   width: '90%',
        //   marginLeft: 'auto',
        //   marginRight: 'auto',
        //
        //   // fontWeight:
        //   // fontWeight: 400,
        //   // lineHeight: 0.95,
        //   // letterSpacing: 2,
        // },
        // h3: {
        //   // color: primaryColor,
        //   fontSize: '1.2rem',
        //   fontWeight: 400,
        //   marginBottom: 30,
        //   paddingBottom: 10,
        //   paddingTop: 10,
        //   textTransform: 'uppercase',
        //   // border: primaryColor + ' 1px solid',
        //   textAlign: 'left',
        // },
        // h4: {
        //   // color: primaryColor,
        //   color: 'inherit',
        //   fontSize: '1.4rem',
        //   fontWeight: 'normal',
        //   textTransform: 'uppercase',
        //   marginBottom: 24,
        // },
        // h5: {
        //   // color: primaryColor,
        //   color: 'inherit',
        //   fontSize: '1.2rem',
        //   // fontWeight: 'bold',
        //   marginTop: '24px',
        //   position: 'relative',
        // },
        // h6: {
        //   // color: primaryColor,
        //   fontSize: '1.1rem',
        //   // paddingBottom: 10,
        //   // paddingTop: 10,
        //   // paddingLeft: 16,
        //   // paddingRight: 16,
        //   // border: primaryColor + ' 1px solid',
        //   textAlign: 'left',
        //   // marginBottom: 32
        // },
        // body1: {
        //   fontSize: '1rem',
        //   color: 'inherit',
        //   color: palette.text.primary,
        // },
        // body2: {
        //   fontSize: '1rem',
        //   // color: '#1D2021',
        // },
        // subtitle1: {
        //   // color: primaryColor,
        //   fontSize: '1rem',
        // },
        // subtitle2: { color: secondaryColor, fontSize: '1rem' },
      },
      breakpoints: {
        values: {
          xs: 0,
          sm: 600,
          md: 960,
          lg: 1280,
          xl: 1920,
        },
      },
      overrides: {
        MuiSvgIcon: {
          root: {
            display: 'inline-block',
            verticalAlign: 'middle',
            marginTop: -3,
            marginRight: 4
          }
        },
        MuiBadge: {
          colorSecondary: {
            backgroundColor: '#B694C5'
          }
        },
        MuiAvatarGroup: {
          avatar: {
            color: palette.secondary.light,
            border: '2px '+palette.secondary.light+' solid',
            backgroundColor: '#fff'
          }
        },
        MuiAvatar: {
          root: {
              border: '2px '+palette.secondary.light+' solid'
          }
        },
        MuiInputLabel: {
          root: {
            fontWeight: 'bold',
            color: '#000',
          }
        },
        MuiButton: {
          root: {
            fontSize: '0.875rem',
            textTransform: 'none',
            borderRadius: 20,
            '& .MuiSvgIcon-root': {
              display: 'inline-block',
              verticalAlign: 'middle',
              marginTop: -2,
              marginRight: 5
            },
            '&.MuiButton-containedPrimary': {
              boxShadow: 'none',
              color: '#fff',
              backgroundColor: palette.secondary.main,
              border: '1px '+palette.secondary.main+' solid',
              borderRadius: '20px'
            },
            '&.MuiButton-containedPrimary:hover': {
              boxShadow: 'none',
              backgroundColor: '#fff',
              color: palette.secondary.main,
            },
            '&.MuiButton-containedSecondary': {
              boxShadow: 'none',
              color: palette.secondary.main,
              backgroundColor: '#fff',
              border: '1px '+palette.secondary.main+' solid'
            },
            '&.MuiButton-containedSecondary:hover': {
              boxShadow: 'none',
              backgroundColor: palette.secondary.main,
              color: '#fff',
            },
            '&$disabled': {
              color: '#fff'
            }
          },
          contained: {
            '&$disabled': {
              color: 'original',
              backgroundColor: 'original',
              opacity: .4
            }
          }
        },
        // MuiFormLabel: {
        //   root: {
        //     // color: '#fff',
        //     '&.Mui-focused': {
        //       // color: primaryColor,
        //     },
        //   },
        // },
        // MuiFormHelperText: {
        //   root: {
        //     color: primaryColor,
        //   },
        // },
        // 'MuiStepper-root': {
        //   padding: 0,
        // },
        // MuiStep: {
        //   root: {
        //     '& > .MuiStepConnector-root': {
        //       display: 'none',
        //     },
        //   },
        // },
        // MuiMenuItem: {
        //   root: {
        //     // color: '#fff',
        //   },
        // },
        // MuiAlert: {
        //   standardSuccess: {
        //     // color: '#fff',
        //     fontWeight: 'bold'
        //   }
        // }
      },
    });

    // theme.overrides.MuiButton.root.boxShadow = theme.shadows[2];
    // theme.typography.h1 = {
    //   ...theme.typography.h1,
    //   marginTop: theme.spacing(2),
    //   marginBottom: theme.spacing(5),
    //   paddingLeft: theme.spacing(2),
    //   paddingRight: theme.spacing(2),
    //   // boxShadow: theme.shadows[3],
    //   [theme.breakpoints.down('md')]: {
    //     fontSize: '1.4rem',
    //   },
    //   [theme.breakpoints.down('sm')]: {
    //     fontSize: '1.3rem',
    //   },
    //   [theme.breakpoints.down('xs')]: {
    //     fontSize: '1.1rem',
    //   },
      // [theme.breakpoints.up('xs')]: {
    //     fontSize: '2.4rem',
    //   },
    //   [theme.breakpoints.up('sm')]: {
    //     fontSize: '3.5rem',
    //   },
    //   [theme.breakpoints.up('md')]: {
    //     fontSize: '4rem',
    //   },
    //   [theme.breakpoints.up('lg')]: {
    //     fontSize: '5rem',
    //   },
    //   [theme.breakpoints.up('xl')]: {
    //     fontSize: '5.5rem',
    //   },
    // };

    // theme.typography.h2 = {
    //   ...theme.typography.h2,
    //   // [theme.breakpoints.up('xs')]: {
    //   //   fontSize: '1.5rem',
    //   //   textAlign: 'center',
    //   // },
    //   // [theme.breakpoints.up('sm')]: {
    //   //   fontSize: '2.2rem',
    //   // },
    //   // [theme.breakpoints.up('md')]: {
    //   //   fontSize: '2.6rem',
    //   //   textAlign: 'left',
    //   //   lineHeight: '4.8rem',
    //   // },
    //   // [theme.breakpoints.up('lg')]: {
    //   //   fontSize: '3rem',
    //   //   lineHeight: '5.2rem',
    //   // },
    //   // [theme.breakpoints.up('xl')]: {
    //   //   fontSize: '3.5rem',
    //   //   lineHeight: '5.8rem',
    //   // },
    // };
    //
    // theme.overrides['MuiContainer'] = {
    //   fixed: {
    //     [theme.breakpoints.down('lg')]: {
    //       maxWidth: '100%',
    //     },
    //   },
    // };

    // console.log('generated theme', theme)
    // console.log('theme debug', getMuiTheme(getCustomPalette(currentUserGroup)))
    return <MuiThemeProvider theme={theme}>{children}</MuiThemeProvider>;
  }
}



// WEBPACK FOOTER //
// ./src/components/Theme.jsx